import { render, staticRenderFns } from "./technical-reviewers.vue?vue&type=template&id=4d7a2324"
import script from "./technical-reviewers.vue?vue&type=script&lang=js"
export * from "./technical-reviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports